import React from 'react';
import type DevopsCreateProjectType from '@atlassian/jira-spa-apps-devops-connected-project/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyDevopsConnectedProject = lazyForPaint<typeof DevopsCreateProjectType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-devops-connected-project", jiraSpaEntry: "async-devops-connected-project" */ '@atlassian/jira-spa-apps-devops-connected-project'
		),
	),
);

const AsyncDevopsConnectedProject = (): React.JSX.Element => (
	<LazyPage Page={LazyDevopsConnectedProject} pageId="devops-connected-project" shouldShowSpinner />
);

export default AsyncDevopsConnectedProject;
